export const GRID_ROW_HEIGHT = 50;
export const GRID_MARGIN = 12;
export const GRID_CONTAINER_PADDING = 12;
export const LG_BREAKPOINT = 1024;
